import qs from 'qs'

export const getIsFromOnlineAppointment = (location) => {
  const { search = '' } = (location || {})
  const { isFromOnlineAppointment } = (qs.parse((search.slice(1))) || {})

  return isFromOnlineAppointment && isFromOnlineAppointment === 'true'
}
